import React from 'react';
import { Radio, Space, Badge, Select } from 'antd';
import { FileImageOutlined, PlayCircleOutlined, FileOutlined, AppstoreOutlined } from '@ant-design/icons';
import Flex from 'components/shared-components/Flex';

const { Option } = Select;

const MediaTypeFilter = ({ activeType, onChange, mediaCounts, isMobile }) => {
    if (isMobile) {
        return (
            <Select
                value={activeType}
                onChange={onChange}
                style={{ width: 125 }}
                dropdownMatchSelectWidth={false}
            >
                <Option value="all">
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <AppstoreOutlined style={{ color: '#1890ff' }} />
                        All ({mediaCounts.all || 0})
                    </span>
                </Option>
                <Option value="image">
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <FileImageOutlined style={{ color: '#52c41a' }} />
                        Images ({mediaCounts.image || 0})
                    </span>
                </Option>
                <Option value="video">
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <PlayCircleOutlined style={{ color: '#722ed1' }} />
                        Videos ({mediaCounts.video || 0})
                    </span>
                </Option>
                <Option value="document">
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <FileOutlined style={{ color: '#fa8c16' }} />
                        Docs ({mediaCounts.document || 0})
                    </span>
                </Option>
            </Select>
        );
    }

    return (
        <Flex>
            <Radio.Group 
                value={activeType} 
                onChange={(e) => onChange(e.target.value)}
                // buttonStyle="solid"
                size="middle"
            >
                <Space size="small" wrap>
                    <Radio.Button value="all">
                        <Flex alignItems="center" gap={5}>
                            <AppstoreOutlined />
                            <span>All</span>
                            <Badge 
                                count={mediaCounts.all} 
                                style={{ backgroundColor: '#1890ff' }} 
                                className="ml-1" 
                            />
                        </Flex>
                    </Radio.Button>
                    <Radio.Button value="image">
                        <Flex alignItems="center" gap={5}>
                            <FileImageOutlined />
                            <span>Images</span>
                            <Badge 
                                count={mediaCounts.image} 
                                style={{ backgroundColor: '#52c41a' }} 
                                className="ml-1" 
                            />
                        </Flex>
                    </Radio.Button>
                    <Radio.Button value="video">
                        <Flex alignItems="center" gap={5}>
                            <PlayCircleOutlined />
                            <span>Videos</span>
                            <Badge 
                                count={mediaCounts.video} 
                                style={{ backgroundColor: '#722ed1' }} 
                                className="ml-1" 
                            />
                        </Flex>
                    </Radio.Button>
                    <Radio.Button value="document">
                        <Flex alignItems="center" gap={5}>
                            <FileOutlined />
                            <span>Documents</span>
                            <Badge 
                                count={mediaCounts.document} 
                                style={{ backgroundColor: '#fa8c16' }} 
                                className="ml-1" 
                                title="Text files, Excel, CSV, PDF, etc."
                            />
                        </Flex>
                    </Radio.Button>
                </Space>
            </Radio.Group>
        </Flex>
    );
};

export default MediaTypeFilter;
